export default __webpack_public_path__ + "static/media/forums.31ad3216.png";